// extracted by mini-css-extract-plugin
module.exports = {"Social":"Social_Social__1yc4T","title":"Social_title__BlL_-","link":"Social_link__3M5BL","images":"Social_images__1NsIR"};